import { z } from 'zod';

import zodLocales from 'common/zod/locales';

export const vatSituationSchema = z.object({
  vatOffset: z.union([z.number(), z.nan()]).nullable(),
  vatRate: z.union([
    z
      .number()
      .nonnegative(zodLocales.errors.positive)
      .step(0.01, {
        message: zodLocales.formatString(
          zodLocales.errors.maxDecimals,
          2,
        ) as string,
      }),
    z.nan(),
  ]),
});

export type VatSituationSchema = z.infer<typeof vatSituationSchema>;
